// extracted by mini-css-extract-plugin
export var blog_tiles = "blog-faketiles-module--blog_tiles--a00ba";
export var color = "blog-faketiles-module--color--40dfb";
export var img = "blog-faketiles-module--img--d88be";
export var price = "blog-faketiles-module--price--8555d";
export var title = "blog-faketiles-module--title--be62a";